import { Flex } from 'onefaceui-react-components';
import styled from 'styled-components';

export const Container = styled(Flex)`
  padding: 0.5rem 1rem;
  border: 1px solid var(--grey-300);

  .field-content {
    [data-testid*='field-input-search'] + svg {
      width: 20px;
      height: 20px;
    }

    > div > div .item button {
      height: auto;
    }

    .remove-all {
      border-radius: 0;
    }
  }
`;

export const ModalFooter = styled(Flex)`
  border-top: solid var(--grey-300) 1px;
  padding: 0.4rem;
`;

export const LoadingContainer = styled(Flex)`
  height: 220px;
  width: 100%;
`;
